export const isNewSessionEnabled = () => {
    if (window.USE_DI_SESSION && window.SESSION_EXPIRES) {
        return true;
    } else {
        return false;
    }
};

const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute('content') || '';
export function getCSRFToken() {
    return csrfToken;
}
